import React, { Component } from 'react'
import { AssignmentView } from '../../components'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as assignmentsAssignmentActionCreators from '../../redux/modules/assignmentsAssignment'
import { db } from '../../config/firebaseconfig'

class AssignmentViewContainer extends Component {
  componentDidMount() {
    const assignmentId = this.props.match.params.id

// *** uncomment once dev is done 

    const activeUser = this.props.user

// ************************************

// hardwire activeUser for dev purposes *************************
/*
    const activeUser = {
      assignments: {
      '5eaaa260-c586-11e7-aaa4-5f88b808e68f': true,
      'dccfa070-c192-11e7-aa36-59c9a4365ff4': false

      },
      createdDate: 1509984211451,
      displayName: 'Student One',
      email: 'pesbatonrouge@gmail.com',
      groups: {
        '1007ae80-c40c-11e7-bcdf-779e5c4415b2': true,
        '3f3521e0-b54f-11e7-9d11-4fd67c837d82': false,
      },
      lastModifiedDate: 1509984211451,
      managesGroups: {
        '1007ae80-c40c-11e7-bcdf-779e5c4415b2': false,
      },
      role: 'Student',
      uid: 'ykpgIBcodOZMfPlYudsEc4rKtXG2'
    }
*/

// Comment out above hardwire once testing is done ***********************

    let assignmentViewing = {}

    const getUserAssignment = (
      db.collection('userAssignments').doc(activeUser.uid).get()
        .then( (doc) => {
          assignmentViewing.userAssignment = doc.data()[assignmentId]
        })
    )

    const getAssignment = (
      db.collection('assignments').doc(assignmentId).get()
        .then( (doc) => {
          assignmentViewing.assignment = doc.data()
        })
    )

    this.props.fetchingAssignment()
    Promise.all([getUserAssignment, getAssignment])
      .then( (values) => {
        this.props.fetchingAssignmentSuccess(assignmentViewing)
      })
      .catch( (err) => {
        console.log(err)
        this.props.fetchingAssignmentError(err)
      })


    // Pull the assignment as well as the userAssignment


  }


  render() {
    return (
      <AssignmentView 
        isFetching={this.props.isFetching}
        assignment={this.props.assignment}
        userAssignment={this.props.userAssignment}
        error={this.props.error}
      />
    )
  }
}

export default connect(
  (state) => ({
    isFetching: state.assignmentsAssignment.isFetching,
    assignment: state.assignmentsAssignment.assignment,
    userAssignment: state.assignmentsAssignment.userAssignment,
    error: state.assignmentsAssignment.error,
    user: state.users.activeUser,
  }),
  (dispatch) => bindActionCreators(assignmentsAssignmentActionCreators, dispatch)
)(AssignmentViewContainer)




/*


export default connect(
  (state) => ({
    assignments: state.assignmentsView.assignments,
    activeAssignment: state.assignmentsView.activeAssignment,
    isFetchingAssignments: state.assignmentsView.isFetchingAssignments,
    error: state.assignmentsView.error,
    activeUserId: state.users.uid,
    activeUser: state.users.activeUser,
    activeUserAssignments: state.assignmentsView.activeUserAssignments,
  }),
  (dispatch) => bindActionCreators(assignmentsViewActionCreators, dispatch)
)(AssignmentsViewContainer)

*/


// WEBPACK FOOTER //
// ./src/containers/Assignments/AssignmentViewContainer.js